module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', _vm._l((_vm.collapses), function(collapse, index) {
    return _c('b-collapse', {
      key: index,
      staticClass: "card",
      attrs: {
        "open": _vm.isOpen == index
      },
      on: {
        "open": function($event) {
          _vm.isOpen = index
        }
      },
      scopedSlots: _vm._u([{
        key: "trigger",
        fn: function(props) {
          return _c('div', {
            staticClass: "card-header",
            attrs: {
              "role": "button"
            }
          }, [_c('p', {
            staticClass: "card-header-title"
          }, [_vm._v("\n                    " + _vm._s(collapse.title) + "\n                ")]), _vm._v(" "), _c('a', {
            staticClass: "card-header-icon"
          }, [_c('b-icon', {
            attrs: {
              "icon": props.open ? 'menu-down' : 'menu-up'
            }
          })], 1)])
        }
      }])
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v("\n                    " + _vm._s(collapse.text) + "\n                ")])])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbceaa2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/collapse/examples/ExAccordion.vue
// module id = 1028
// module chunks = 19 151